export enum EEnvTypes {
    DEV = 'dev',
    PROD = 'production',
    PRE = 'pre',
    STAGE = 'stage',
    PREVIEW = 'preview',
}
